import Joi from '@hapi/joi'

export const CollectioncategoryCollectiontypeSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    productID: Joi.number().invalid(0).required().label("Product").messages({
        "any.invalid": `Product cannot have invalid characters`,
        "any.required": `Product required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Category").messages({
        "any.invalid": `Collection Category have invalid characters`,
        "any.required": `Collection Category required`
    })
}

export const CollectioncategoryCollectiontypeEditSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    productID: Joi.number().invalid(0).required().label("Product").messages({
        "any.invalid": `Product cannot have invalid characters`,
        "any.required": `Product required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collectioncatagory Name").messages({
        "string.empty": `Collectioncatagory Name required`,
        "string.pattern.base": `Please enter valid Collectioncatagory Name`,
    }),
    isActive: Joi.boolean().label("Active"),
    isDefault: Joi.boolean().label("Default")
}